
import lazyload from "@/directives/lazyload";
import Sam from "@/assets/images/landing/img/sam.webp";
import Noah from "@/assets/images/landing/img/noah.webp";
import Luke from "@/assets/images/landing/img/luke.webp";
import Kelly from "@/assets/images/landing/img/Kelly.png";
import SaraK from "@/assets/images/landing/img/SaraK.png";
import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "Luke W.",
          text:
            `I bumped into her at a local charity softball game. Man, she was a breath of fresh air – super chill and all in with the kids there. So I thought, why not? Asked her out a few times and we had some legit fun. But she would be distracted on her phone most of the time. Then I remembered one of my friends experience with iFindCheaters and knows how to catch a cheater on social media. Gave it a try and, no joke, found her actively seeking other people. I’m just glad I looked it up – saved myself time and energy I can invest in a genuine person. Now I'm all about doing a little online recon before letting feelings get involved in.`,
          imgMain: Luke,
          imgSecond: Noah,
          imgThird: Sam,
          logo: LogoAmerican,
        },
        {
          name: "Noah S.",
          text:
            `Sarah and I usually have this cute habit of sending each other texts throughout the day. So one afternoon, while at her place, her phone buzzed from the kitchen counter. Thinking it might be a message I sent earlier, I glanced over. To my surprise, it wasn't my message but a flirty text from a name I didn't recognize. I tried not to overthink it, giving her the benefit of the doubt. Later that evening, she sensed something was off and I decided to open up about what I saw. She brushed it off as 'just a friend,' but the doubt had planted its seed in my mind. I couldn’t shake the feeling off, so I turned to <strong>iFindCheaters’ catch cheaters texting</strong> tool. To my dismay, I discovered frequent exchanges with the same name over the past month. It was a hard pill to swallow. While confronting the truth was tough, I'm glad I wasn’t left in the dark for long.`,
          imgMain: Noah,
          imgSecond: Sam,
          imgThird: Luke,
          logo: LogoAmerican,
        },
        {
          name: "Sam P.",
          text:
            `Just became official with this guy I’d been seeing for the past few months, and everything seemed great at first. But then there were these odd moments – late replies, vague plans. My gut kept nudging me, so I decided to give iFindCheaters a shot as it claimed to <strong>catch cheaters texting</strong>. And there it was: Mark's not-so-innocent exchanges with another dude. It stung, but I'm genuinely grateful for the wake-up call. This platform might've saved me from a whole lot of heartache down the road.`,
          imgMain: Sam,
          imgSecond: Luke,
          imgThird: Noah,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
